export class AppConstants {

    // metide server
    //public static SITE_URL = 'https://delios-staging-backend.metide.com/';
    //public static IMAGE_URL = 'https://delios-staging-backend.metide.com/storage/';

    // delios live server
    public static SITE_URL = 'https://solarportal.midacbatteries.com/api/';
    public static IMAGE_URL = 'https://solarportal.midacbatteries.com/api/storage/';

    // local
    // public static SITE_URL = 'http://delios-backend.local/';
    // public static IMAGE_URL = 'http://delios-backend.local/storage/';

    //testing
    //public static SITE_URL = 'http://127.0.0.1:8000/';
    //public static IMAGE_URL = 'http://127.0.0.1:8000/storage/';

    // public static SITE_URL = 'https://test-mqtt.webportal-backend.delios-srl.it/';
    // public static IMAGE_URL = 'https://test-mqtt.webportal-backend.delios-srl.it/storage/';
}


// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/constant/app.constants.ts